import styled, { css } from 'styled-components';
import { BUTTON_UNIKEY } from '../../define/global';
import { bottonCommon } from './CssCommon';
import ga from '../../utils/gaConnect';
import { useAppDataSliceSelector } from '../../store/modules/appData';

const ButtonInner = styled.button`
  ${bottonCommon}

  &:hover {
    background: #edeff0;
  }
  &:active {
    background: #e0e0e0;
  }

  ${({ primary }) =>
    primary &&
    css`
      background: #1d7ff9;
      color: #fff;
      border: none;
      &:hover {
        background: #4b9afc;
      }
      &:active {
        background: #0b65d4;
      }
      &:disabled {
        pointer-events: none;
        opacity: 0.6;
      }
    `}

  outline: none;

  ${({ cssExt }) => cssExt && cssExt}
`;

function Button({
  onClick,
  cssExt,
  children,
  uniKey,
  executeTime,
  primary,
  block,
  disabled,
  autoFocus
}) {
  const appData = useAppDataSliceSelector();

  const sendButtonGAData = () => {
    let gaData = undefined;
    switch (uniKey) {
      case BUTTON_UNIKEY.SHARED_LINK_GEN_BTN:
        gaData = { category: '공유', action: '공유생성', value: executeTime };
        break;
      case BUTTON_UNIKEY.SHARED_LINK_COPY_NEW_BTN:
        gaData = { category: '공유', action: '신규링크복사' };
        break;
      case BUTTON_UNIKEY.SHARED_LINK_COPY_EXIST_BTN:
        gaData = { category: '공유', action: '기존링크복사' };
        break;
      case BUTTON_UNIKEY.PO_INSTALL_BTN:
        gaData = { category: 'Polaris Office 설치', action: '설치 바로가기 연결' };
        if (appData.shareId !== '') gaData.label = '공유뷰';
        break;
      default:
        break;
    }

    if (gaData !== undefined) ga.event(gaData);
  };

  const onClickInner = (e) => {
    // alert('inner');
    sendButtonGAData();
    if (onClick) onClick(e);
  };

  return (
    <ButtonInner
      onClick={(e) => onClickInner(e)}
      cssExt={cssExt}
      primary={primary}
      block={block}
      disabled={disabled}
      autoFocus={autoFocus}>
      {children}
    </ButtonInner>
  );
}

export default Button;
